export default __webpack_public_path__ + "static/media/TodayGettingStarted.36f53386.png";